
const Config = {};

export default Config;


// WEBPACK FOOTER //
// ./src/util/Config.js